import { render, staticRenderFns } from "./TableSendFieldsContainer.vue?vue&type=template&id=4ff2929a&"
import script from "./TableSendFieldsContainer.vue?vue&type=script&lang=js&"
export * from "./TableSendFieldsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports